import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';
import { graphql } from 'react-relay';

const regionalInfoFragment = graphql`
    fragment userGeoInfo_regionalInfo on RegionalInfo {
        zipCode
        countryCode
        incomeLevel(zipCode: $zipCode) {
            incomeBracket
            incomePercentile
        }
    }
`;

const incomeLevelMap = {
    higher: 'tier 1',
    high: 'tier 2',
    mid: 'tier 3',
    low: 'tier 4',
};

const USER_GEO_INFO = 'userGeoInfo';
// valid period is set to 30 days
const USER_ZIP_CODE_VALID_PERIOD = 2592000000;
const USER_ZIP_CODE_VALID_SHORT_PERIOD = 86400000;

function getIncomeLevelInfo(regionalInfo = {}) {
    const incomeLevel =
        get(localStorage.getItem(USER_GEO_INFO), 'incomeLevel') ||
        get(regionalInfo, '[0].incomeLevel') ||
        {};
    const { incomeBracket, incomePercentile } = incomeLevel;
    return incomeBracket && incomePercentile
        ? `${incomeLevelMap[incomeBracket.toLowerCase()]}| ${incomePercentile}`
        : undefined;
}

function getUserLocalStorageZipCode() {
    const userGeoInfo = localStorage.getItem(USER_GEO_INFO);
    return get(userGeoInfo, 'zipCode') || '';
}

function getUserLocalStorageCountryCode() {
    const userGeoInfo = localStorage.getItem(USER_GEO_INFO);
    return get(userGeoInfo, 'countryCode') || '';
}

function hasValidLocalUserGeoInfo() {
    const userGeoInfo = localStorage.getItem(USER_GEO_INFO) || {};
    const zipCode = getUserLocalStorageZipCode();
    const countryCode = getUserLocalStorageCountryCode();
    const incomeLevel = get(userGeoInfo, 'incomeLevel');
    // checking if zipCode is set
    // "0" is valid zipCode set from digital elements for private IP addresses
    if (zipCode && countryCode) {
        const timeDiff = Date.now() - userGeoInfo.timestamp;
        const validPeriod =
            zipCode === '0' ? USER_ZIP_CODE_VALID_SHORT_PERIOD : USER_ZIP_CODE_VALID_PERIOD;

        // Checking for users which has valid zipCode
        // But doesn't have incomeLevel
        // Will fetch incomeLevel with zipCode stored in localStorage as arg
        if (typeof incomeLevel === 'undefined' && zipCode !== '0') {
            return false;
        }

        if (!timeDiff || timeDiff <= validPeriod) {
            return true;
        }
    }
    return false;
}

function setLocalUserGeoInfo(viewer) {
    const zipCode = get(viewer, 'regionalInfo[0].zipCode');
    const countryCode = get(viewer, 'regionalInfo[0].countryCode');
    const { incomeBracket, incomePercentile } = get(viewer, 'regionalInfo[0].incomeLevel') || {};
    const timestamp = Date.now();
    if (zipCode) {
        localStorage.setItem(USER_GEO_INFO, {
            timestamp,
            zipCode,
            countryCode,
            incomeLevel: {
                incomeBracket,
                incomePercentile,
            },
        });
    }
}

export {
    setLocalUserGeoInfo,
    hasValidLocalUserGeoInfo,
    regionalInfoFragment,
    USER_GEO_INFO,
    getIncomeLevelInfo,
    getUserLocalStorageZipCode,
    getUserLocalStorageCountryCode,
};
